import React from "react";
import "../Marq/Marq.css";

const Marq = () => {
  return (
    <section className="marq-section">
      <div className="marq-wrapper">
        <div className="marq-track">
          <span>Save upto GBP100 · Phone only Deals</span>
          <span>Save upto GBP100 · Phone only Deals</span>
          <span>Save upto GBP100 · Phone only Deals</span>
        </div>
      </div>
    </section>
  );
};

export default Marq;